import { render, staticRenderFns } from "./accountDetails.vue?vue&type=template&id=ace5a0d8&scoped=true&"
import script from "./accountDetails.vue?vue&type=script&lang=js&"
export * from "./accountDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace5a0d8",
  null
  
)

export default component.exports